<div class="wrapper wrapper_lg air air_horz">
    <!-- only mobile -->
    <div class="row">
        <div class="flex-column col-lg-4 l-grey">
              <app-login-form></app-login-form> 
           
        <div>
        <div class="col-lg-8 l-white">  
            <div class="login ml-lg-10 mt-lg-10">
                <div class="flex-column justify-content-center">
                       <p class="h-4 text-left ml-3 mr-3"><br><b>TransForma Connect</b></p>
                    <p class="text-left ml-3 mr-3">
TransForma Connect is a platform of introduction. Select your specialties and build your profile. You will be contacted by dental practices that need your skills, directly to your device, in real time.<br>Profiles and communication with employers is private, between you and only those seeking your credentials.</p>
                        <!--<p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p> <button class="btn w-100 btn-lg btn-lg btn-primary mt-3" routerLink="/officeform">&nbsp;&nbsp;Create Company Profile&nbsp;&nbsp;</button> -->
                         <button class="btn w-100 btn-lg btn-outline-primary mt-3" routerLink="/proform">Create Professional Profile</button>
                         <div class="d-flex w-100 mt-4 justify-content-center">
                            <img src="assets/img/ui/prof1.jpg" width="auto" height="140" />
                           <img src="assets/img/ui/prof4.jpg" width="auto" height="140" />
                       </div>
              </div>
               <p>&nbsp;</p>
            </div>
             <p>&nbsp;</p>
        </div>
        <p>&nbsp;</p>
        <p>&nbsp;</p>
        <div id="loginForm"></div>
    </div>
</div>
<app-footer></app-footer>